import React, { Component } from "react";
import { Modal, Input, InputNumber, DatePicker, Empty, message } from "antd";
import { PlusOutlined, DeleteOutlined, EnvironmentOutlined, CalendarOutlined } from "@ant-design/icons";
import moment from "moment";
import { ButtonItem } from "../../../../Components/Items";
import { cmmsPost, fechaDiaPayload, momentFechaDia } from "../cmmsComun";
import "../cmms.css";

// Listas de los viajes que viven en Configuracion CMMS:
// - tipo "destinos": destinos con sus km de ida y vuelta (se proponen al capturar un viaje).
// - tipo "festivos": dias festivos (se marcan en Viajes y Agenda y no se usan al repartir el programa).
// props: visible, tipo, valores (los actuales), onClose(huboCambio)
const TEXTOS = {
    destinos: {
        titulo: "Destinos",
        subtitulo: "Municipios o ciudades con sus km de ida y vuelta. Al capturar un viaje se proponen solos.",
        icono: <EnvironmentOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />,
        vacio: "Sin destinos: se agregan solos al registrar viajes con km.",
        agregar: "Agregar destino",
    },
    festivos: {
        titulo: "Días festivos",
        subtitulo: "Se marcan en Viajes y en la Agenda, y no se usan al repartir automáticamente el programa de un contrato.",
        icono: <CalendarOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />,
        vacio: "Sin días festivos.",
        agregar: "Agregar día festivo",
    },
};

class ModalListasViajesCMMS extends Component {
    state = { filas: [], guardando: false };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible)
            this.setState({
                filas: (this.props.valores || []).map((v, i) =>
                    this.props.tipo === "festivos" ? { key: `f${i}`, fecha: momentFechaDia(moment, v.fecha), nombre: v.nombre || "" } : { key: `d${i}`, _id: v._id, nombre: v.nombre, km: v.km || null }
                ),
            });
    }

    cambiar = (key, cambios) => this.setState((s) => ({ filas: s.filas.map((f) => (f.key === key ? { ...f, ...cambios } : f)) }));

    agregar = () =>
        this.setState((s) => ({ filas: [...s.filas, this.props.tipo === "festivos" ? { key: `n${Date.now()}`, fecha: null, nombre: "" } : { key: `n${Date.now()}`, nombre: "", km: null }] }));

    guardar = async () => {
        const festivos = this.props.tipo === "festivos";
        this.setState({ guardando: true });
        try {
            const res = festivos
                ? await cmmsPost(this.props, "guardarDiasFestivosCMMS", { dias: this.state.filas.filter((f) => f.fecha).map((f) => ({ fecha: fechaDiaPayload(f.fecha), nombre: f.nombre })) })
                : await cmmsPost(this.props, "guardarDestinosViajeCMMS", { destinos: this.state.filas.filter((f) => String(f.nombre || "").trim()).map(({ _id, nombre, km }) => ({ _id, nombre, km })) });
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo guardar");
            message.success(festivos ? "Días festivos guardados" : "Destinos guardados");
            this.props.onClose(true);
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const t = TEXTOS[this.props.tipo] || TEXTOS.destinos;
        const festivos = this.props.tipo === "festivos";
        const filas = festivos ? [...this.state.filas].sort((a, b) => (a.fecha ? a.fecha.valueOf() : Infinity) - (b.fecha ? b.fecha.valueOf() : Infinity)) : this.state.filas;
        return (
            <Modal
                className="cmms-modal"
                visible={this.props.visible}
                onCancel={() => this.props.onClose(false)}
                onOk={this.guardar}
                okText="Guardar"
                cancelText="Cancelar"
                confirmLoading={this.state.guardando}
                width={window.innerWidth > 700 ? 560 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        {t.icono}
                        <div>
                            <div className="cmms-modal-titulo-texto">{t.titulo}</div>
                            <div className="cmms-modal-subtitulo">{t.subtitulo}</div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo">
                    {!filas.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t.vacio} /> : null}
                    {filas.map((f) => (
                        <div key={f.key} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                            {festivos ? (
                                <>
                                    <DatePicker format="DD/MM/YYYY" value={f.fecha} onChange={(fecha) => this.cambiar(f.key, { fecha })} style={{ width: 150 }} />
                                    <Input placeholder="Ej. Día de la Constitución" maxLength={80} value={f.nombre} onChange={(e) => this.cambiar(f.key, { nombre: e.target.value })} />
                                </>
                            ) : (
                                <>
                                    <Input placeholder="Ej. RIOVERDE" maxLength={80} value={f.nombre} onChange={(e) => this.cambiar(f.key, { nombre: e.target.value })} />
                                    <InputNumber min={0} max={20000} placeholder="Km" value={f.km} onChange={(km) => this.cambiar(f.key, { km })} style={{ width: 120 }} />
                                </>
                            )}
                            <ButtonItem type="default" htmlType="button" rojo lessTime icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ filas: s.filas.filter((x) => x.key !== f.key) }))} />
                        </div>
                    ))}
                    <ButtonItem type="dashed" htmlType="button" blanco lessTime icon={<PlusOutlined />} onClick={this.agregar} style={{ marginTop: 4 }}>
                        {t.agregar}
                    </ButtonItem>
                </div>
            </Modal>
        );
    }
}

export default ModalListasViajesCMMS;
